export const ALBERT_EVENTS = {
  GET_QUOTE: 'albert_get_quote',
  CHOOSE_PLAN: 'albert_choose_plan',
  PAYMENT_INFO: 'albert_payment_info',
  PURCHASE: 'albert_purchase',
};

/**
 * @description Estos selectores CSS son utilizados por el equipo de Albert para identificar los eventos que se disparan desde el aplicativo
 */
export const SELECTORES_CSS = {
  GENERAL: {
    btnContinuar: 'sc-fnGiBr bpSirJ',
  },
  HOGAR: {
    btnContinuarContratante: 'sc-fnGiBr bpSirJ',
  },
};
